export default __webpack_public_path__ + "static/media/sec2.7655bdce.png";